import React, { useEffect, useState } from "react";
// import Table from "react-bootstrap/Table";
import Swal from "sweetalert2";
import GlobalURL from "../baseUrl";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
import { IoCaretDownSharp, IoCaretUpSharp } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import ReactPaginate from 'react-paginate';

import "./pstyle.css";
import Header from "../components/header";
import { useNavigate } from "react-router-dom";
import {
  performVerification,
  tokenVerification,
} from "../commonFunc/verification";
import { LuCircleChevronLeft } from "react-icons/lu";

import { useDispatch, useSelector } from "react-redux";
import translations from "../locals/translation";

import { useLocation } from "react-router-dom";
import { fetchVendors } from "../redux/vendorSlice";

function VendorsList() {
  const state = useLocation();

  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const navigate = useNavigate();
  const [loading] = useState(false);
  const [password, setPassword] = useState("");
  const [reason, setReason] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const [show, setShow] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showReas, setShowReas] = useState(false);
  const handleClose = () => setShow(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const [idDel] = useState("");
  const [ueload, setUeload] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const itemsPerPageOptions = [5, 10, 20, 50, 100];
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  async function getAllVendorsFunc() {
    const responseData = state.state;
    if (state.state == null || state.state === undefined) {
      navigate("/dashboard");
      return;
    }
    if (responseData.data.length === 0) {
      setData([]);
      return;
    }
    if (responseData.status_code === 200) {
    }
    if (responseData.status_code === 400) {
      Swal.fire(responseData.message);
      return;
    }
    setData(responseData.data);
    console.log('responseData.data of vendor : ', responseData.data);
    setOriginalData(responseData.data);
  }
  const useFunction = async () => {
    if (state.state == null || state.state === undefined) {
      navigate("/dashboard");
      return;
    }
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    setShowPass(false);
    const requestData = {
      truck_id: idDel,
      password: password,
    };

    try {
      const url = `${GlobalURL}/api/dev/admin/deleteTruck`;
      const headers = {
        "Content-Type": "application/json",
        lang_id: language,
        token: `${Newtoken}`,
        "ngrok-skip-browser-warning": "69420",
      };

      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((data) => {
          if (data.status_code === 200) {
            Swal.fire(data.message);
          } else if (data.status_code === 404) {
            Swal.fire(data.message);
          } else if (data.status_code === 400) {
            Swal.fire(data.message);
          } else if (data.status_code === 401) {
            Swal.fire(data.message);
          } else {
            Swal.fire(t("Server Error"));
          }

          if (data.status_code !== 200) {
            Swal.fire("Error", data.message, "error");
            return;
          }
          setShowPass(false);
          Swal.fire(data.message);
          setUeload(!ueload);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
          Swal.fire(t("Server Error"));
        });
    } catch (error) {
      console.log(error);
    }
  };
  const suspendContinue = async () => {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    if (!reason) {
      Swal.fire({
        title: t("Justification!"),
        text: t("Justification Required"),
        icon: "error",
      });
      return;
    }
    setShowReas(false);
    const url = `${GlobalURL}/api/dev/admin/suspendTruck`;

    const headers = {
      "Content-Type": "application/json",
      lang_id: language,
      token: `${Newtoken}`,
      "ngrok-skip-browser-warning": "69420",
    };

    const requestData = {
      truck_id: idDel,
      message: reason,
    };

    try {
      const response = await fetch(url, {
        method: "POST", // Use the appropriate HTTP method (GET, POST, etc.)
        mode: "cors",
        headers,
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.status_code === 200) {
        Swal.fire({ text: data.message, icon: "success" });
      } else if (data.status_code === 404) {
        Swal.fire(data.message);
      } else if (data.status_code === 400) {
        Swal.fire(data.message);
      } else if (data.status_code === 401) {
        Swal.fire(data.message);
      }
      setReason("");
      setUeload(!ueload);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  const dispatch = useDispatch();
  const showDetails = (vendor) => {
    navigate("/truckDetails", { state: { td: vendor } });
  };
  const sortAscending = () => {
    const ascendingOrder = [...data].sort((a, b) => {
      const nameA = a.first_name.toUpperCase();
      const nameB = b.first_name.toUpperCase();
      return nameA.localeCompare(nameB);
    });
    setData(ascendingOrder);
  };
  const sortDescending = () => {
    const descendingOrder = [...data].sort((a, b) => {
      const nameA = a.first_name.toUpperCase();
      const nameB = b.first_name.toUpperCase();
      return nameB.localeCompare(nameA);
    });
    setData(descendingOrder);
  };
  const userNameAsc = () => {
    const sortedAsc = [...data].sort((a, b) =>
      a.username.localeCompare(b.username)
    );
    setData(sortedAsc);
  };
  const userNameDsc = () => {
    const sortedDesc = [...data].sort((a, b) =>
      b.username.localeCompare(a.username)
    );
    setData(sortedDesc);
  };

  const handleSearchChange = (e) => {
    let data3 = originalData;
    const inputValue = e.target.value.toLowerCase();
    if (inputValue === "") {
      setData(originalData);
      setSearchInput("");
      return;
    }
    // Filter the data based on all three fields
    const result = data3.filter((item) =>
      Object.values(item).some(
        (value) =>
          typeof value === "string" && value.toLowerCase().includes(inputValue)
      )
    );

    if (result.length === 0) {
      setData([]);
    }
    setSearchInput(inputValue);
    setData(result);
  };
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    if (key === 'name') {
      direction === 'asc' ? sortAscending() : sortDescending();
    } else if (key === 'username') {
      direction === 'asc' ? userNameAsc() : userNameDsc();
    }
  };
  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    if (state.state == null || state.state === undefined) {
      navigate("/dashboard");
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("Ue executed: ");
    dispatch(fetchVendors());
    getAllVendorsFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ueload]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0); // Reset to first page when changing page size
  };
  const paginatedData = data.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  console.log('paginatedData: ', paginatedData);

  const handleMakeActivInact = async (id, check) => {
    const confirmation = await Swal.fire({
      title: check ? "Verify Vendor?" : "Unverify Vendor?",
      text: `Are you sure you want to ${check ? "verify" : "unverify"} this vendor?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: check ? "Yes, verify" : "Yes, unverify",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    try {
      const resp = await fetch(`${GlobalURL}/api/dev/admin/verifyVendor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          vendor_id: id,
          is_verified: check,
        }),
      });

      const dataResponse = await resp.json();

      if (dataResponse.status_code === 200) {
        // Update local data array
        const updated = data.map((vendor) =>
          vendor.vendor_id === id ? { ...vendor, is_verified: check } : vendor
        );

        setData(updated); // update main state
        setOriginalData(updated); // update original state in case of filtering

        await Swal.fire({
          icon: "success",
          title: "Success",
          text: `Vendor ${check ? "verified" : "unverified"} successfully`,
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: dataResponse.message || "Failed to update verification status",
        });
      }
    } catch (error) {
      console.error("Error verifying vendor:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred during verification",
      });
    }
  };


  return (
    <React.Fragment>
      <Header />
      <div className="login-heading">
        <h1 style={{ marginTop: "80px" }}>{t("Vendors List")}</h1>
        <h5>{t("List of all the vendors associated with the application")}</h5>
        <div className="search-back-parent">
          <div className="search-back">
            <LuCircleChevronLeft
              fill="none"
              className="back-button"
              onClick={() => navigate(-1)}
            />
            <div className="input-with-search">
              <input
                placeholder={t("search")}
                value={searchInput}
                onChange={handleSearchChange}
                className="searchInput"
              />
              <IoIosSearch />

            </div>
          </div>
        </div>
        {/* <div className="table-div-vendors">
        </div> */}
        <div className="table-div-vendors">
          <div className="table-container">
            <table className="custom-table">
              <thead>
                <tr>
                  <th style={{ cursor: 'pointer', color: '#431118', userSelect: 'none' }} onClick={() => handleSort('name')}>
                    {t("Name")}
                    {sortConfig.key === 'name' && (
                      sortConfig.direction === 'asc' ? (
                        <IoCaretUpSharp style={{ marginLeft: 4, color: '#431118', verticalAlign: 'middle' }} />
                      ) : (
                        <IoCaretDownSharp style={{ marginLeft: 4, color: '#431118', verticalAlign: 'middle' }} />
                      )
                    )}
                  </th>
                  <th style={{ cursor: 'pointer', color: '#431118', userSelect: 'none', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 4 }} onClick={() => handleSort('username')}>
                    <span>{t("Username")}</span>
                    {sortConfig.key === 'username' && (
                      sortConfig.direction === 'asc' ? (
                        <IoCaretUpSharp style={{ color: '#431118', verticalAlign: 'middle', margin: 0 }} />
                      ) : (
                        <IoCaretDownSharp style={{ color: '#431118', verticalAlign: 'middle', margin: 0 }} />
                      )
                    )}
                  </th>
                  <th>{t("Email")}</th>
                  <th>{t("Address")}</th>
                  <th>{t("City")}</th>
                  <th>{t("State")}</th>
                  <th>{t("Zip Code")}</th>
                  <th>{t("Phone")}</th>
                  <th>{t("Registered At")}</th>
                  <th style={{ width: "13%" }}>{t("Details")}</th>
                  <th>{t("IsActive")}</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9" className="loading-cell">
                      <div className="loading-spinner"></div>
                      <p className="logging-heading">{t("Loading")}</p>
                    </td>
                  </tr>
                ) : paginatedData.length ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{item.first_name} {item.last_name}</td>
                      <td>{item.username}</td>
                      <td>{item.email}</td>
                      <td>{item.address || "-"}</td>
                      <td>{item.city || "-"}</td>
                      <td>{item.state || "-"}</td>
                      <td>{item.zip_code || "-"}</td>
                      <td>{item.phone || "-"}</td>
                      <td>{item.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}</td>
                      <td
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          color: "#007BFF",
                        }}
                        onClick={() => showDetails(item)}
                      >
                        {t("Truck details")}
                      </td>
                      <td>
                        <label className="switch">
                          <input type="checkbox" onClick={() => { handleMakeActivInact(item.vendor_id, !item.is_verified) }} checked={item.is_verified} />
                          <span className="slider round"></span>
                        </label>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="no-data">
                      {t("No data Found")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}>
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                previousClassName={"page-item"}
                nextClassName={"page-item"}
                breakClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousLinkClassName={"page-link"}
                nextLinkClassName={"page-link"}
                breakLinkClassName={"page-link"}
                forcePage={currentPage}
              />
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <label htmlFor="itemsPerPage" style={{ fontSize: 14, color: '#431118', marginRight: 4 }}>{t("Show")}</label>
            <select
              id="itemsPerPage"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              style={{ borderRadius: 6, border: '1px solid #431118', padding: '4px 8px', fontSize: 14 }}
            >
              {itemsPerPageOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
            <span style={{ fontSize: 14, color: '#431118' }}>{t("entries")}</span>
          </div>
        </div>

      </div>
    </React.Fragment>
  );
}

export default VendorsList;
